import { render } from "./Jegyzokonyv.vue?vue&type=template&id=f39ec8a0"
import script from "./Jegyzokonyv.vue?vue&type=script&lang=js"
export * from "./Jegyzokonyv.vue?vue&type=script&lang=js"

import "./Jegyzokonyv.vue?vue&type=style&index=0&id=f39ec8a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__